import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseDataGroupFromConversation, RDataGroup} from './dataGroupModel';

/*
 * Runtime type.
 */

export const RConversationSplit = t.readonly(
  t.type({
    originalDataGroup: RDataGroup,
    destinationDataGroup: RDataGroup,
  }),
);

/*
 * Type.
 */

export interface ConversationSplitModel extends t.TypeOf<typeof RConversationSplit> {}

/*
 * IO methods.
 */

export function parseConversationSplit(src: any): ConversationSplitModel {
  return {
    originalDataGroup: src.conversation_orig && parseDataGroupFromConversation(src.conversation_orig),
    destinationDataGroup: src.conversation_dest && parseDataGroupFromConversation(src.conversation_dest),
  };
}

/*
 * API type.
 */

export const ApiConversationSplit = makeApiType(
  'conversationSplit',
  RConversationSplit,
  parseConversationSplit,
);
